@if (!short) {
  @if (request) {
    <rt-box
      [class.open-candidate]="openCandidateOnClick"
      [class.own]="isOwn(request.admin)"
      (click)="openCandidate(request)"
      variant="default vertical no-padding"
      margin-bottom
    >
      <div class="box-header" padding-small>
        <div layout-horizontal layout-align-items-center margin-right-small margin-top-small-xx>
          @if (isStatus('pending')) {
            <rt-icon name="timer-sand" margin-right-small-xx> </rt-icon>
          }
          @if (!request.admin?.anonymizedAt) {
            <rt-avatar
              [type]="
                !request.triggered ? (request.admin?.hasAvatar ? 'image' : 'initials') : 'icon'
              "
              [initials]="request.admin?.initials"
              [size]="'small'"
              [shape]="'oval'"
              [imageSrc]="
                request.triggered ? null : (request.admin && request.admin.photoThumbUrl) || null
              "
              iconColor="colorIconOncomponentDefault"
              [attr.margin-left-small-x]="!isStatus('pending') ? '' : null"
              iconName="automated-actions"
              [context]="request.triggered ? 'other' : 'admin'"
            >
            </rt-avatar>
          }
          @if (request.admin?.anonymizedAt) {
            <rt-avatar type="icon" size="small" shape="oval" iconName="person" context="admin" />
          }
        </div>
        <div layout-vertical layout-space-between layout-flex-1 margin-top-small-xx>
          <div [attr.margin-bottom-small-xx]="!inDashboard ? '' : null">
            @if (request.admin; as admin) {
              <rt-heading variant="heading">
                @if (!admin.anonymizedAt) {
                  <span>{{ admin.firstName }} {{ admin.lastName }}</span>
                }
                @if (admin.anonymizedAt) {
                  <span> {{ 'app.common.deleted_user' | translate }}</span>
                }
              </rt-heading>
            }
            @if (!openEventModalOnClick) {
              <rt-heading variant="subheading normal" margin-lr-small-xx> - </rt-heading>
              @if (request.admin) {
                <rt-heading
                  [rtTooltip]="request.offer?.title"
                  [rtTooltipPosition]="'right'"
                  variant="subheading normal"
                >
                  {{ request.interviewTemplate.name }}
                </rt-heading>
              }
            }
          </div>
          @if (inDashboard) {
            <div layout-centered-y>
              <span>
                {{ request.candidate.name }}
              </span>
              @if (request.offer || request.talentPool; as requestOffer) {
                <rt-offer-status-indicator [offerStatus]="requestOffer">
                </rt-offer-status-indicator>
                {{ requestOffer.title }}
              }
            </div>
          }
          @if (request.interviewEvent) {
            <div class="details">
              @if (request.requestedBy) {
                <span>
                  {{ 'app.interview.requested_by' | translate }} {{ request.requestedBy }}
                </span>
              }
              @if (openEventModalOnClick) {
                <a
                  [rtTooltip]="state.meetingDate"
                  (click)="openEventModal($event, request)"
                  class="event-link color-light"
                >
                  ({{ 'app.interview.kind.' + request.interviewEvent.kind | translate }})
                </a>
              }
              @if (!openEventModalOnClick && request.interviewEvent) {
                <span [rtTooltip]="state.meetingDate">
                  ({{ 'app.interview.kind.' + request.interviewEvent.kind | translate }})
                </span>
              }
              <rt-date [time]="request.createdAt" variant="default color-light"> </rt-date>
            </div>
          }
          @if (!request.interviewEvent) {
            <div layout-horizontal-wrap layout-align-items-center>
              <rt-heading [showIcon]="false" variant="subheading light">
                @if (!request.triggered) {
                  <span>
                    {{ 'app.interview.requested_by' | translate }}
                    {{
                      !!request.requestedBy?.length
                        ? request.requestedBy
                        : ('app.common.deleted_user' | translate)
                    }}
                  </span>
                }
                @if (request.triggered) {
                  <span>
                    {{ 'app.interview.requested' | translate }}
                  </span>
                }
                <rt-date [time]="request.createdAt" variant="default" margin-left-small-xx>
                </rt-date>
              </rt-heading>
            </div>
          }
        </div>
        @if (isOwn(request.admin) && isStatus('pending')) {
          <rt-group variant="stacked horizontal" layout-align-items-start layout-justify-flex-end>
            <ng-container
              *ngTemplateOutlet="startButton; context: { variant: 'tertiary' }"
            ></ng-container>

            <rt-icon-button
              variant="tertiary"
              shape="square"
              iconName="close"
              [loading]="state.loading === 'dismiss'"
              [rtTooltip]="'app.interview.dismiss' | translate"
              (click)="dismiss($event, request.id)"
            >
            </rt-icon-button>
          </rt-group>
        }
        @if (isOwn(request.admin) && isStatus('dismissed')) {
          <rt-group layout-justify-flex-end>
            <rt-icon-button
              [loading]="state.loading === 'revert'"
              [rtTooltip]="'app.interview.revert' | translate"
              (click)="revert($event, request.id)"
              variant="plain"
              iconName="replay"
              shape="square"
            >
            </rt-icon-button>
          </rt-group>
        }
        @if (
          (hasHighLevelDataAccess || (!isOwn(request.admin) && isCreatedByAdmin())) &&
          isStatus('pending')
        ) {
          <rt-group layout-justify-flex-end>
            <rt-icon-button
              [loading]="state.loading === 'delete'"
              [rtTooltip]="'app.interview.delete' | translate"
              (click)="delete($event, request.id)"
              variant="plain"
              iconName="close"
              shape="square"
            >
            </rt-icon-button>
          </rt-group>
        }
      </div>
    </rt-box>
  }
}

@if (short) {
  <rt-box
    [class.own]="isOwn(request.admin)"
    variant="default vertical no-padding"
    margin-bottom-small
  >
    <div class="box-header" padding-lr-small-x padding-tb-small>
      <div
        [class.own]="isOwn(request.admin)"
        class="short"
        layout-horizontal
        layout-flex-1
        layout-align-items-center
      >
        @if (isStatus('pending')) {
          <rt-icon name="timer-sand" margin-right-small-xx> </rt-icon>
        }
        @if (!request.admin?.anonymizedAt) {
          <rt-avatar
            [type]="request.admin?.hasAvatar ? 'image' : 'initials'"
            [initials]="request.admin?.initials"
            [size]="'small'"
            [shape]="'oval'"
            [imageSrc]="(request.admin && request.admin.photoThumbUrl) || null"
            iconName="person"
            margin-right-small-x
          >
          </rt-avatar>
        }
        @if (request.admin?.anonymizedAt) {
          <rt-avatar
            type="icon"
            size="small"
            shape="oval"
            iconName="person"
            context="admin"
            margin-right-small-x
          />
        }
        <rt-heading variant="heading">
          <rt-truncate>{{ request.interviewTemplate.name }}</rt-truncate> </rt-heading
        >&nbsp;
        @if (request.admin; as admin) {
          <rt-heading variant="subheading normal">
            -
            <div margin-left-small-xx>
              @if (!admin.anonymizedAt) {
                <rt-truncate
                  >{{ request.admin.firstName }} {{ request.admin.lastName }}</rt-truncate
                >
              }
              @if (admin.anonymizedAt) {
                <rt-truncate>{{ 'app.common.deleted_user' | translate }}</rt-truncate>
              }
            </div>
          </rt-heading>
        }
      </div>
      <div layout layout-align-items-center layout-justify-flex-end>
        @if (isOwn(request.admin) && isStatus('pending')) {
          <rt-group variant="stacked horizontal">
            <ng-container
              *ngTemplateOutlet="startButton; context: { variant: 'tertiary' }"
            ></ng-container>
            <rt-icon-button
              [loading]="state.loading === 'dismiss'"
              [rtTooltip]="'app.interview.dismiss' | translate"
              (click)="dismiss($event, request.id)"
              variant="tertiary"
              shape="square"
              iconName="close"
            >
            </rt-icon-button>
          </rt-group>
        }
      </div>
    </div>
  </rt-box>
}
<ng-template #startButton let-variant="variant">
  <rt-button
    #dropdownOrigin="rtOverlayOrigin"
    [variant]="variant"
    (click)="startInterview($event)"
    rt-overlay-origin
  >
    <rt-icon name="play-arrow"></rt-icon>
    <span>{{ 'app.interview.start' | translate }}</span>

    <ng-template
      #selectActionDropdown="rtConnectedOverlay"
      [hasBackdrop]="true"
      [origin]="dropdownOrigin"
      [positions]="dropdownConfig"
      (backdropClick)="selectActionDropdown.open = false"
      rt-connected-overlay
    >
      <rt-dropdown>
        <rt-dropdown-header [fullWidthTitle]="true">
          {{ 'app.interview.give_evaluation_about' | translate }}
        </rt-dropdown-header>
        <div rtScrollable class="scroll-wrap">
          <rt-dropdown-item (click)="openCandidateDialogWithInterview()">
            <div layout layout-vertical>
              {{ 'app.interview.candidate' | translate | uppercase }}
              <span class="dropdown-item-subheading">
                {{ 'app.interview.evaluation_unrelated' | translate }}
              </span>
            </div>
          </rt-dropdown-item>
          @for (placement of request.candidatePlacements; track trackByOfferId($index, placement)) {
            <rt-dropdown-item
              (click)="
                openCandidateDialogWithInterview(placement.offerId || placement.talentPoolId!)
              "
            >
              <rt-offer-status-indicator
                [offerStatus]="$any(placement)"
                margin-right-small-x
              ></rt-offer-status-indicator>
              {{ placement.title }}
            </rt-dropdown-item>
          }
        </div>
      </rt-dropdown>
    </ng-template>
  </rt-button>
</ng-template>
